const MerlinActionTypes = {
  MERLIN_GENERATE_TOKEN: 'MERLIN_GENERATE_TOKEN',
  MERLIN_GENERATE_TOKEN_SUCCESS: 'MERLIN_GENERATE_TOKEN_SUCCESS',
  MERLIN_GENERATE_TOKEN_FAIL: 'MERLIN_GENERATE_TOKEN_FAIL',
  MERLIN_SET_URL: 'MERLIN_SET_URL',
  MERLIN_RESET: 'MERLIN_RESET',
  MERLIN_SET_CHAT_DATA: 'MERLIN_SET_CHAT_DATA',
  MERLIN_SET_MIGRATION_DATA: 'MERLIN_SET_MIGRATION_DATA',
  POC_SEND_DOUBT: 'POC_SEND_DOUBT',
  POC_REQUEST_ANSWER: 'POC_REQUEST_ANSWER',
  POC_SET_RESPONSE: 'POC_SET_RESPONSE',
  POC_RENDER_INHOUSE_CHAT: 'POC_RENDER_INHOUSE_CHAT',
  POC_MINIMIZE_INHOUSE_CHAT: 'POC_MINIMIZE_INHOUSE_CHAT',
  POC_VISIBILITY_INHOUSE_CHAT: 'POC_VISIBILITY_INHOUSE_CHAT',
  SEND_AUDIO_MESSAGE: 'SEND_AUDIO_MESSAGE',
  GET_AUDIO_TRANSCRIPTION: 'GET_AUDIO_TRANSCRIPTION',
  SET_LOADING_TRANSCRIPTION: 'SET_LOADING_TRANSCRIPTION',
  SET_TRANSCRIPTION_ERROR: 'SET_TRANSCRIPTION_ERROR',
  AI_CHAT_RATE_MESSAGE: 'AI_CHAT_RATE_MESSAGE',
  AI_CHAT_RATE_MESSAGE_SUCCESS: 'AI_CHAT_RATE_MESSAGE_SUCCESS',
  AI_CHAT_RATE_MESSAGE_FAILURE: 'AI_CHAT_RATE_MESSAGE_FAILURE',
  AICHAT_SET_CHAT_STATE: 'AICHAT_SET_CHAT_STATE',
  TOGGLE_FULLSCREEN: 'TOGGLE_FULLSCREEN',
  SET_MAIA_AGENT: 'SET_MAIA_AGENT',
  SET_SIDE_CONTENT: 'SET_SIDE_CONTENT',
  RESET_SIDE_CONTENT: 'RESET_SIDE_CONTENT',
  SET_EXTERNAL_MESSAGE: 'SET_EXTERNAL_MESSAGE',
  GENERATE_THREAD_ID: 'GENERATE_THREAD_ID',
  SET_ROUTE: 'SET_ROUTE',
  SET_EXTERNAL_AUDIO_BLOB: 'SET_EXTERNAL_AUDIO_BLOB',
};

export { MerlinActionTypes };
